export default __webpack_public_path__ + "static/media/hyperVideo.b6d76e48.webm";